import { render, staticRenderFns } from "./UserBanControl.vue?vue&type=template&id=549d4e90&scoped=true&"
import script from "./UserBanControl.vue?vue&type=script&lang=js&"
export * from "./UserBanControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d4e90",
  null
  
)

export default component.exports